export default __webpack_public_path__ + "static/media/en-flag.db3b2118.svg";